import { render, staticRenderFns } from "./SignupUnderMaintenance.vue?vue&type=template&id=aec89a96&scoped=true"
import script from "./SignupUnderMaintenance.vue?vue&type=script&lang=js"
export * from "./SignupUnderMaintenance.vue?vue&type=script&lang=js"
import style0 from "./SignupUnderMaintenance.vue?vue&type=style&index=0&id=aec89a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec89a96",
  null
  
)

export default component.exports